import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import CustomTextField from "../Reusable/Numerictext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Collapse, FormGroup, Stack, Box, Backdrop, createTheme, ThemeProvider, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel, Radio } from '@mui/material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { blue } from '@mui/material/colors';
import { saveAs } from 'file-saver';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import SearchIcon from '@mui/icons-material/Search';
import { Button as Btn, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
const styles = {
  tableContainer: {
    maxHeight: '400px',
    overflowY: 'auto',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: blue[500], // Using MUI blue primary color
    color: '#ffffff',
    textAlign: 'center',
    fontSize: '1rem',
  },
  bodyCell: {
    padding: '12px 16px',
    textAlign: 'center',
    fontSize: '0.875rem',
  },
  debitCreditCell: {
    padding: '12px 16px',
    textAlign: 'right',
    fontSize: '0.875rem',
  },
  tableRow: (index) => ({
    backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#ffffff',
  }),
};

export default function Mdpapproval() {

  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
  const userGroupCode = localStorage.getItem('usertype');
  const token = localStorage.getItem('Token');

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [subdealerlist, setsubdealerlist] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isCheckedbrach, setisCheckedbrach] = useState(false);
  const [isCheckedexecutive, setisCheckedexecutive] = useState(false);
  const [isCheckedcommon, setisCheckedcommon] = useState(false);
  const [isCheckedcomplete, setisCheckedcomplete] = useState(false);
 const [open, setOpen] = React.useState(false);

  // const [rows, setRows] = useState(filteredItems);

  // const handleRadioChange = (index, field) => {
  //   if (index < 0 || index >= rows.length) {
  //     console.error("Invalid index:", index);
  //     return;
  //   }

  //   const updatedRows = [...rows];  // Copy the current state of rows
  //   const row = updatedRows[index];

  //   // Check if row exists
  //   if (!row) {
  //     console.error("Row not found at index", index);
  //     return;
  //   }

  //   // Reset the values for other fields when one is selected
  //   if (field === 'APPROVED') {
  //     row.APPROVED = 'True';
  //     row.REJ_IND = 'False';
  //     row.NOCHANGE = 'False';
  //   } else if (field === 'REJ_IND') {
  //     row.REJ_IND = 'True';
  //     row.APPROVED = 'False';
  //     row.NOCHANGE = 'False';
  //   } else if (field === 'NOCHANGE') {
  //     row.NOCHANGE = 'True';
  //     row.APPROVED = 'False';
  //     row.REJ_IND = 'False';
  //   }

  //   // Update the rows state with the modified items
  //   setRows(updatedRows);
  // };



  const handleBranchChange = (event, selectedOption) => {
    setSelectedBranch(selectedOption);
  };



  // Handle checkbox state change
  const handleassignCheckboxChange = (event) => {
    setisCheckedbrach(event.target.checked);
  };
  const handleexecutiveCheckboxChange = (event) => {
    setisCheckedexecutive(event.target.checked);
  };
  const handlecommonCheckboxChange = (event) => {
    setisCheckedcommon(event.target.checked);
  };
  const handlecompleteCheckboxChange = (event) => {
    setisCheckedcomplete(event.target.checked);
  };
  const handleGroupChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setSelectedGroup(selectedOption);  // Update the selected branch
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdpgetBranches', { login_id, userGroupCode: userGroupCode });

        if (response.status === 200) {
          const branchData = response.data.branches;

          if (branchData && branchData.length > 0) {
            // Map the response to format { value: BRANCH_CODE, label: BRANCH_NAME }
            const formattedBranches = branchData.map((branch) => ({
              value: branch.BRANCH_CODE,
              label: branch.BRANCH_NAME,
            }));

            setBranches(formattedBranches);

            console.log('branches', branches);

            // Set the first branch as the default selection
            setSelectedBranch(formattedBranches[0]);
          }

        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.',
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`,
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };

    fetchData();
  }, [login_id]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdpexecutiveid', { login_id: login_id, BranchCode: BRANCH_CODE, userGroupCode: userGroupCode });
        // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
        if (response.status === 200) {
          // setsubdealerlist(response.data.DEALER_CODE);
          const dealerdata = response.data.executives;
          const common = response.data.common_visible;

          const Subdealer_List = dealerdata.map((type) => ({
            value: type.LOGINID,
            label: type.USER_NAME,
          }));




          setsubdealerlist(Subdealer_List);
          setSelectedGroup(Subdealer_List[0]);


        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, []);

  const [approvallist, setapprovallist] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [mdpgrid, setmdpgrid] = useState([]);
  let mdpgrid1 = mdpgrid || [];


  const filteredItems = mdpgrid1.filter((row) => {
    const lowerSearchTerm = searchTerm.toLowerCase();

    return (
      (row.DOC_NO && row.DOC_NO.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_NAME && row.DEALER_NAME.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_CODE && row.DEALER_CODE.toLowerCase().includes(lowerSearchTerm)) ||
      (row.CREATEDBY && row.CREATEDBY.toLowerCase().includes(lowerSearchTerm)) ||
      (row.CREATEDBY_NAME && row.CREATEDBY_NAME.toLowerCase().includes(lowerSearchTerm))
    );
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/loadmdpapprovallist', { login_id: login_id });
        if (response.status === 200) {
          setapprovallist(response.data.Approvallist);
          setmdpgrid(response.data.Approvallist);
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        setOpen(false);
        if (error.response) {
          // Swal.fire({
          //   icon: "warning",
          //   text: `Error: ${error.response.data.message}`
          // });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, []);



  const [checkboxState, setCheckboxState] = useState({});

  // useEffect(() => {
  //   setCheckboxState(approvallist.map(item => ({
  //     docNo: item.DOC_NO,
  //     approveChecked: item.approveChecked || false,
  //     rejectChecked: item.rejectChecked || false,
  //     pendingChecked: item.pendingChecked || false,
  //   })));
  // }, [approvallist]);

  // const handleCheckboxChange = (docNo, type) => {

  //   setCheckboxState(prevState => {
  //     return prevState.map(item => {
  //       if (item.docNo === docNo) {
  //         return {
  //           ...item,
  //           [`${type}Checked`]: !item[`${type}Checked`], // Toggle the checkbox
  //         };
  //       }
  //       return item;
  //     });
  //   });
  // };

  const [updatedData, setUpdatedData] = useState({});
  useEffect(() => {
    const initialState = approvallist.reduce((acc, item) => {
      acc[item.DOC_NO] = {
        approveChecked: item.approveChecked || false,
        rejectChecked: item.rejectChecked || false,
        // pendingChecked: item.pendingChecked || false,
      };
      return acc;
    }, {});
    setCheckboxState(initialState);
  }, [approvallist]);

  // Handle checkbox change with custom logic to uncheck others
  const handleCheckboxChange = (docNo, type) => {
    setCheckboxState(prevState => {
      const updatedState = {
        ...prevState,
        [docNo]: {
          approveChecked: false,
          rejectChecked: false,
          // pendingChecked: false,
        },
      };

      // Set the checked state for the selected checkbox
      updatedState[docNo][`${type}Checked`] = true;

      return updatedState;
    });
  };


  

  const [tableData, setTableData] = useState(approvallist);

  const sendDataToAPI = async () => {
    setOpen(true);
    try {
      // Gather the data
      const data = gatherTableData();
  
      // Send the data to the backend
      const response = await axios.post(BASE_URL + '/saveApprovalData', { data,login_id: login_id });
  
      // Handle the response
     if (response.status === 200) {
            setOpen(false);
                          Swal.fire({
                              icon: "success",
                              text: response.data.text || 'Data saved successfully!',
                          }).then((result) => {
                            setOpen(false);
                              if (result.isConfirmed) {
                                  window.location.reload();
                              }
                          });
          } else {
            setOpen(false);
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.',
        });
      }
    } catch (error) {
      setOpen(false);
      if (error.response) {
        Swal.fire({
          icon: "error",
          text: `Error: ${error.response.data.message}`,
        });
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  };

  // const gatherTableData = () => {
  //   // Prepare the array to hold all the table data
  //   const dataToSend = approvallist.map(row => {
  //     const rowState = checkboxState[row.DOC_NO] || {};
  
  //     return {
  //       DOC_NO: row.DOC_NO,
  //       APPROVED_BUDGET: row.APPROVED_BUDGET,
  //       DEALER_CONTRIBUTION: row.DEALER_CONTRIBUTION,
  //       EXPECTEDRESULT: row.EXPECTEDRESULT,
  //       APPROVE: rowState.approveChecked || false,
  //       REJECT: rowState.rejectChecked || false,
  //       PENDING: rowState.pendingChecked || false,
  //       AC_FROM_DATE: row.AC_FROM_DATE,
  //       AC_TO_DATE: row.AC_TO_DATE,
  //     };
  //   });
  
  //   return dataToSend;
  // };
  const gatherTableData = () => {
    // Prepare the array to hold all the table data
    const dataToSend = approvallist.map(row => {
      const rowState = checkboxState[row.DOC_NO] || {};
      const updatedBudget = updatedData[row.DOC_NO]?.APPROVED_BUDGET || row.APPROVED_BUDGET;
      
      // Determine which status to set: APPROVE, REJECT, or PENDING
      let status = null;
      if (rowState.approveChecked) {
        status = 'APPROVE';
      } else if (rowState.rejectChecked) {
        status = 'REJECT';
      } 
      // else if (rowState.pendingChecked) {
      //   status = 'PENDING';
      // }
      
      // Only return the data if status is not null
      if (status != null) {
        return {
          DOC_NO: row.DOC_NO,
          APPROVED_BUDGET: updatedBudget,
          DEALER_CONTRIBUTION: row.DEALER_CONTRIBUTION,
          EXPECTEDRESULT: row.EXPECTEDRESULT,
          APPROVE: status === 'APPROVE',
          REJECT: status === 'REJECT',
          // PENDING: status === 'PENDING',
          AC_FROM_DATE: row.AC_FROM_DATE,
          AC_TO_DATE: row.AC_TO_DATE,
        };
      }
  
      // If no status, return nothing or null, depending on your needs.
      return null;
    }).filter(row => row !== null); // Filter out any null values if no status is set
  
    return dataToSend;
  };
  const handleTextFieldChange = (docNo, field, value) => {

    

    setUpdatedData(prevState => ({
      ...prevState,
      [docNo]: {
        ...prevState[docNo],
        [field]: value || null // If empty, set to null
      }
    }));
  };

  const handlesubmit = async () => {

    setOpen(true);
    const data = {
      login_id: login_id,
      Branch: selectedBranch.value,
      Executive: selectedGroup.value, // Corrected 'Exective' to 'Executive' and 'Value' to 'value'
      isbranch: isCheckedbrach, // Corrected 'isbrach' to 'isbranch'
      isexecutive: isCheckedexecutive, // Corrected 'iseexecutive' to 'isexecutive'
      iscommon: isCheckedcommon,
      iscomplete: isCheckedcomplete
    };
  
    try {
      const response = await axios.post(BASE_URL + '/loadmdpapprovallist', { login_id: login_id, 
        Branch: selectedBranch.value,
      Executive: selectedGroup.value, // Corrected 'Exective' to 'Executive' and 'Value' to 'value'
      isbranch: isCheckedbrach, // Corrected 'isbrach' to 'isbranch'
      isexecutive: isCheckedexecutive, // Corrected 'iseexecutive' to 'isexecutive'
      iscommon: isCheckedcommon,
      iscomplete: isCheckedcomplete
       });
  
      if (response.status === 200) {
        setapprovallist(response.data.Approvallist);
        setmdpgrid(response.data.Approvallist);
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.'
        });
      }
    } catch (error) {
      setOpen(false);
      if (error.response) {
        // Swal.fire({
        //   icon: "warning",
        //   text: `Error: ${error.response.data.message}`
        // });
      } else if (error.request) {
        console.error('No response received');
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  };

  return (
    <div>
      <div className="container" style={{ justifyContent: 'center' }}>
        <br />


       
        <div className='row'>
          <div className='col-md-4'>
            {/* <label ></label> */}
            <Autocomplete
              label="Branch"
              required={true}
              options={branches}  // Pass the mapped branches here
              value={selectedBranch}  // Set the selected branch
              onChange={handleBranchChange}  // Handle the change event
              getOptionLabel={(option) => option.label}  // Define how to display the label
              isOptionEqualToValue={(option, value) => option.value === value.value}  // Custom comparison function
              renderInput={(params) => <TextField {...params} label="Branch" />}
            />
          </div>
          <div className='col-md-2'>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      checked={isCheckedbrach}
      onChange={handleassignCheckboxChange}
      id="branchCheckbox"
    />
    <label className="form-check-label" htmlFor="branchCheckbox">
      Selected Branch only
    </label>
  </div>
</div>
          <div className='col-md-4'>

            <Autocomplete
              label="Dealer Code"
              required={true}
              options={subdealerlist}  // Pass the mapped branches here
              value={selectedGroup}  // Set the selected branch
              onChange={handleGroupChange}  // Handle the change event
              getOptionLabel={(option) => option.label}  // Define how to display the label
              isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
              renderInput={(params) => <TextField {...params} label="Dealer Code" />}
            />
          </div>

          <div className='col-md-2'>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      checked={isCheckedexecutive}
      onChange={handleexecutiveCheckboxChange}
      id="execCheckbox"
    />
    <label className="form-check-label" htmlFor="execCheckbox">
      Selected Executive only
    </label>
  </div>
</div>

          
        </div>
<br />
<div className='row' >
<div className='col-md-3'>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      checked={isCheckedcommon}
      onChange={handlecommonCheckboxChange}
      id="commonCheckbox"
    />
    <label className="form-check-label" htmlFor="commonCheckbox">
      Select Common Activity 
    </label>
  </div>
</div>

<div className='col-md-3'>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      checked={isCheckedcomplete}
      onChange={handlecompleteCheckboxChange}
      id="commonCheckbox"
    />
    <label className="form-check-label" htmlFor="commonCheckbox">
      Select Complete Activity 
    </label>
  </div>
</div>
  <div className="col-md-4">
                    {/* <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button> */}
                    <Button size="small" fullWidth variant="contained" onClick={handlesubmit} ><b>SUBMIT</b></Button>
                    </div>

</div>

      </div>

      <div>
        <br />
        {/* <TextField
          id="filled-search"
          label="Search field"
          type="search"
          variant="filled"

          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: <SearchIcon />,
          }}
        /> */}
        <TableContainer component={Paper} sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}>
          <Table>
            <TableHead >
              <TableRow>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Doc No.</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Budget</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Activity Code</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Activity</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>From Dt.</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>To Dt.</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Activity Objective</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Document Dt</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Dealer</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Dealer Name</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Approved Budget</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Budget Remarks</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Dealer Contribution</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Dealer Contribution Remarks</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Expected Result</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Executive Code</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Executive Name</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Approve</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Reject</TableCell>
                {/* <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>Pending</TableCell> */}
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>AC From Dt.</TableCell>
                <TableCell sx={{  background: '#61d1e5', color: 'black', fontSize: '14px', position: 'sticky', top: 0, zIndex: 1 }}>AC To Dt.</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {approvallist.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ fontSize: '14px' }}>
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                approvallist.map((row, index) => {
                  // Find the corresponding checkbox state for this row
                  const rowState = checkboxState[row.DOC_NO]

                  return (
                    <TableRow key={index}>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.DOC_NO}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.BUDGET}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.ACTIVITY_TYPE}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.ACTIVITY_DESC}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        {new Date(row.FROM_DATE).toLocaleDateString()}
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        {new Date(row.TO_DATE).toLocaleDateString()}
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.DESCRIPTION}</TableCell>
                     
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        {new Date(row.CREATEDON).toLocaleDateString()}
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.DEALER_CODE}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.DEALER_NAME}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                      <TextField
                  value={updatedData[row.DOC_NO]?.APPROVED_BUDGET || row.APPROVED_BUDGET || ''}
                  onChange={(e) => handleTextFieldChange(row.DOC_NO, 'APPROVED_BUDGET', e.target.value)}
                />
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.BUDGET_REMARK}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        <TextField value={row.DEALER_CONTRIBUTION} sx={{ width: 75 }} />
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        {row.DEALER_CONTRIBUTION_REMARK}
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.EXPECTEDRESULT}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.CREATEDBY}</TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>{row.CREATEDBY_NAME}</TableCell>

                      {/* Add Checkboxes for Approve, Reject, and Pending */}
                      <TableCell sx={{ padding: '10px', background: '#e3fafe' }}>
                        <Checkbox
                          checked={rowState ? rowState.approveChecked : false}
                          onChange={() => handleCheckboxChange(row.DOC_NO, 'approve')}
                        />
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe'}}>
                        <Checkbox
                          checked={rowState ? rowState.rejectChecked : false}
                          onChange={() => handleCheckboxChange(row.DOC_NO, 'reject')}
                        />
                      </TableCell>
                      {/* <TableCell sx={{ padding: '10px', background: '#e3fafe'}}>
                        <Checkbox
                          checked={rowState ? rowState.pendingChecked : false}
                          onChange={() => handleCheckboxChange(row.DOC_NO, 'pending')}
                        />
                      </TableCell> */}

                      <TableCell sx={{ padding: '10px', background: '#e3fafe', fontSize: '14px' }}>
                      {row.AC_FROM_DATE && !isNaN(new Date(row.AC_FROM_DATE).getTime()) 
  ? new Date(row.AC_FROM_DATE).toLocaleDateString() 
  : ''}
                        {/* {new Date(row.AC_FROM_DATE).toLocaleDateString()} */}
                      </TableCell>
                      <TableCell sx={{ padding: '10px', background: '#e3fafe'}}>
                      {row.AC_TO_DATE && !isNaN(new Date(row.AC_TO_DATE).getTime()) 
  ? new Date(row.AC_TO_DATE).toLocaleDateString() 
  : ''}
                        {/* {new Date(row.AC_TO_DATE).toLocaleDateString()} */}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <br />
        <Button onClick={sendDataToAPI} size="small" fullWidth variant="contained" >Save Changes</Button>

        
 <br />

                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
      </div>
    </div>
  );
};


